webpackJsonp([20],{

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(568),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__order__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'orders-list',
  components: {
    'order': __WEBPACK_IMPORTED_MODULE_0__order___default.a
  },
  methods: {
    selectOrder: function selectOrder(order) {
      this.$store.dispatch('selectOrder', order);
    },
    next: function next() {
      this.$store.commit('nextPage');
      this.$store.dispatch(this.refreshMethod);
    },
    prev: function prev() {
      this.$store.commit('prevPage');
      this.$store.dispatch(this.refreshMethod);
    },
    refreshList: function refreshList() {
      this.$store.commit('changeItemsPerPage', this.ipp);
      this.$store.dispatch(this.refreshMethod);
    }
  },
  computed: {
    pagingText: function pagingText() {
      return 'mostrando de ' + ((this.$store.getters.currentPage - 1) * this.$store.getters.itemsPerPage + 1) + ' a ' + this.$store.getters.currentPage * this.$store.getters.itemsPerPage + ' de ' + this.$store.getters.totalItems;
    },
    filteredOrders: function filteredOrders() {
      var _this = this;

      if (this.searchOrders === '') {
        return this.tabOrder;
      } else {
        return this.tabOrder.filter(function (elem) {
          var exp = new RegExp(_this.searchOrders.trim(), 'i');
          var itens = elem.itens.map(function (elem) {
            return elem.name;
          }).join('');
          var searchItem = elem.register + elem.condominium.name + elem.condominium.address + elem.condominium.addressNumber + elem.condominium.neighborhood + elem.condominium.city + elem.condominium.state + elem.condominium.administrator + itens + __WEBPACK_IMPORTED_MODULE_1_moment___default()(elem.date).format('DD/MM/YYYY');
          return exp.test(searchItem);
        });
      }
    },
    searchOrders: function searchOrders() {
      return this.$store.getters.searchOrders;
    },
    currentPage: function currentPage() {
      return this.$store.getters.currentPage;
    },
    itemsPerPage: function itemsPerPage() {
      return this.$store.getters.itemsPerPage;
    },
    totalPages: function totalPages() {
      return this.$store.getters.totalPages;
    }
  },
  data: function data() {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    };
  }
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  methods: {
    orderDetails: function orderDetails(id) {
      this.$store.dispatch('selectOrder', id);
    }
  },
  computed: {
    price: function price() {
      // return this.value.itens.reduce((prevVal, elem) => {
      //   return prevVal + (elem.price * elem.count)
      // }, this.value.price)
      return this.value.itens.reduce(function (prevVal, elem) {
        return prevVal + elem.count * elem.price;
      }, 0);
    }
  },
  filters: {
    currency: function currency(value) {
      if (typeof value !== 'number') return '';
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    calendar: function calendar(value) {
      // debugger
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).calendar(null, {
        sameDay: '[Hoje às] h:mm a',
        nextDay: '[Tomorrow] h:mm a',
        nextWeek: '[Próxima] dddd',
        lastDay: '[Ontem às] h:mm a',
        lastWeek: 'dddd [passada]',
        sameElse: 'DD MMM [às] h:mm a'
      });
      // return moment(value).format('LLL')
    }
  }
});

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".card-container{height:100%}.order-list{padding:10px}.order-list>div{border-radius:10px;border:1px solid #8e8e8e}.fs-18{font-size:18px}.new{color:red!important}.order-details-btn div{background:#0264c7;padding:5px 10px;float:left;color:#fff;cursor:pointer}.order-status:after{content:\" \";display:block;height:calc(100% - 40px);border-left:1px solid #c7c7c7;width:1px;margin:auto;margin-top:10px}.order-color{color:#767676}.list .order-status{opacity:0}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/pedidos/OrderList/order.vue"],"names":[],"mappings":"AACA,gBACE,WAAa,CACd,AACD,YACE,YAAc,CACf,AACD,gBACE,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,OACE,cAAgB,CACjB,AACD,KACE,mBAAqB,CACtB,AACD,uBACE,mBAAoB,AACpB,iBAAkB,AAClB,WAAY,AACZ,WAAY,AACZ,cAAgB,CACjB,AACD,oBACE,YAAa,AACb,cAAe,AACf,yBAA0B,AAC1B,8BAA+B,AAC/B,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AACD,aACE,aAAa,CACd,AACD,oBACE,SAAW,CACZ","file":"order.vue","sourcesContent":["\n.card-container {\n  height: 100%;\n}\n.order-list{\n  padding: 10px;\n}\n.order-list>div{\n  border-radius: 10px;\n  border: 1px solid #8e8e8e;\n}\n.fs-18{\n  font-size: 18px;\n}\n.new{\n  color: red!important;\n}\n.order-details-btn div{\n  background: #0264c7;\n  padding: 5px 10px;\n  float: left;\n  color: #fff;\n  cursor: pointer;\n}\n.order-status::after{\n  content: ' ';\n  display: block;\n  height: calc(100% - 40px);\n  border-left: 1px solid #c7c7c7;\n  width: 1px;\n  margin: auto;\n  margin-top: 10px;\n}\n.order-color{\n  color:#767676\n}\n.list .order-status{\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("4fc4cc85", content, true, {});

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "md4 xs12 order-list"
  }, [_c('v-container', {
    staticClass: "card-container",
    staticStyle: {
      "flex-direction": "column"
    },
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "fluid": "",
      "d-flex": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('strong', {
    staticClass: "fs-18 "
  }, [_vm._v("\n          Pedido ref.:   \n        ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-18 titulo-detalhes "
  }, [_vm._v(" " + _vm._s(_vm.value.identifier) + " ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm._f("calendar")(_vm.value.date)) + "\n      ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_vm._v("\n        " + _vm._s(_vm.value.condominium.name)), _c('br'), _vm._v("\n        Cliente: " + _vm._s(_vm.value.client)), _c('br'), _vm._v("\n        Unidade: " + _vm._s(_vm.value.unit)), _c('br')])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-2": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "order-color"
  }, [_c('strong', [_vm._v("Itens Pedidos")]), _c('br'), _vm._v(" "), _vm._l((_vm.value.itens), function(item) {
    return [_c('span', [_vm._v("\n            " + _vm._s(item.name) + ";\n          ")])]
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-end": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "fs-18 mt-1"
  }, [_c('strong', [_vm._v("Valor total")]), _vm._v(": " + _vm._s(_vm._f("currency")(_vm.price)) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "elevation-0 order-details-btn ma-0",
    on: {
      "click": function($event) {
        return _vm.orderDetails(_vm.value.id)
      }
    }
  }, [_vm._v("+ detalhes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "mb-10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-4": ""
    }
  }, _vm._l((_vm.filteredOrders), function(order, i) {
    return _c('order', {
      key: i,
      attrs: {
        "list": "",
        "value": order
      },
      on: {
        "details": function($event) {
          return _vm.details($event)
        }
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "v-subheader theme--light"
  }, [_vm._v("itens por página")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "single-line": "",
      "value": _vm.itemsPerPage,
      "bottom": "",
      "required": "",
      "items": _vm.comboList
    },
    on: {
      "change": _vm.refreshList
    },
    model: {
      value: (_vm.ipp),
      callback: function($$v) {
        _vm.ipp = $$v
      },
      expression: "ipp"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "pt-3 pr-2 mb-0"
  }, [_vm._v(_vm._s(_vm.pagingText))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage > 1),
      expression: "currentPage > 1"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage < _vm.totalPages),
      expression: "currentPage < totalPages"
    }],
    attrs: {
      "fab": "",
      "rounded": "",
      "outlined": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderList__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OrderList__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'canceled-orders',
  extends: __WEBPACK_IMPORTED_MODULE_0__OrderList___default.a,
  computed: {
    tabOrder: function tabOrder() {
      return this.$store.getters.canceledOrders;
    },
    refreshMethod: function refreshMethod() {
      return 'getCanceledOrders';
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getCanceledOrders');
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.7ceaa675baa58d7b5f50.js